(function (factory) {
	window.MoverRamda = factory(window.R || require("ramda"));
})(
	function (R) {
		"use strict";

		/*! *****************************************************************************
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the Apache License, Version 2.0 (the "License"); you may not use
    this file except in compliance with the License. You may obtain a copy of the
    License at http://www.apache.org/licenses/LICENSE-2.0

    THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
    KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
    WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
    MERCHANTABLITY OR NON-INFRINGEMENT.

    See the Apache Version 2.0 License for specific language governing permissions
    and limitations under the License.
    ***************************************************************************** */

		var __assign = function () {
			__assign =
				Object.assign ||
				function __assign(t) {
					for (var s, i = 1, n = arguments.length; i < n; i++) {
						s = arguments[i];
						for (var p in s)
							if (Object.prototype.hasOwnProperty.call(s, p))
								t[p] = s[p];
					}
					return t;
				};
			return __assign.apply(this, arguments);
		};

		function createCommonjsModule(fn, module) {
			return (
				(module = { exports: {} }),
				fn(module, module.exports),
				module.exports
			);
		}

		/** 不执行注销操作 */
		var isStopLoginout = false;

		var js_cookie = createCommonjsModule(function (module, exports) {
			(function (factory) {
				var registeredInModuleLoader;
				{
					module.exports = factory();
					registeredInModuleLoader = true;
				}
				if (!registeredInModuleLoader) {
					var OldCookies = window.Cookies;
					var api = (window.Cookies = factory());
					api.noConflict = function () {
						window.Cookies = OldCookies;
						return api;
					};
				}
			})(function () {
				function extend() {
					var i = 0;
					var result = {};
					for (; i < arguments.length; i++) {
						var attributes = arguments[i];
						for (var key in attributes) {
							result[key] = attributes[key];
						}
					}
					return result;
				}

				function decode(s) {
					return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
				}

				function init(converter) {
					function api() {}

					function set(key, value, attributes) {
						if (typeof document === "undefined") {
							return;
						}

						attributes = extend(
							{
								path: "/",
							},
							api.defaults,
							attributes
						);

						if (typeof attributes.expires === "number") {
							attributes.expires = new Date(
								new Date() * 1 + attributes.expires * 864e5
							);
						}

						// We're using "expires" because "max-age" is not supported by IE
						attributes.expires = attributes.expires
							? attributes.expires.toUTCString()
							: "";

						try {
							var result = JSON.stringify(value);
							if (/^[\{\[]/.test(result)) {
								value = result;
							}
						} catch (e) {}

						value = converter.write
							? converter.write(value, key)
							: encodeURIComponent(String(value)).replace(
									/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g,
									decodeURIComponent
							  );

						key = encodeURIComponent(String(key))
							.replace(
								/%(23|24|26|2B|5E|60|7C)/g,
								decodeURIComponent
							)
							.replace(/[\(\)]/g, escape);

						var stringifiedAttributes = "";
						for (var attributeName in attributes) {
							if (!attributes[attributeName]) {
								continue;
							}
							stringifiedAttributes += "; " + attributeName;
							if (attributes[attributeName] === true) {
								continue;
							}

							// Considers RFC 6265 section 5.2:
							// ...
							// 3.  If the remaining unparsed-attributes contains a %x3B (";")
							//     character:
							// Consume the characters of the unparsed-attributes up to,
							// not including, the first %x3B (";") character.
							// ...
							stringifiedAttributes +=
								"=" + attributes[attributeName].split(";")[0];
						}

						return (document.cookie =
							key + "=" + value + stringifiedAttributes);
					}

					function get(key, json) {
						if (typeof document === "undefined") {
							return;
						}

						var jar = {};
						// To prevent the for loop in the first place assign an empty array
						// in case there are no cookies at all.
						var cookies = document.cookie
							? document.cookie.split("; ")
							: [];
						var i = 0;

						for (; i < cookies.length; i++) {
							var parts = cookies[i].split("=");
							var cookie = parts.slice(1).join("=");

							if (!json && cookie.charAt(0) === '"') {
								cookie = cookie.slice(1, -1);
							}

							try {
								var name = decode(parts[0]);
								cookie =
									(converter.read || converter)(
										cookie,
										name
									) || decode(cookie);

								if (json) {
									try {
										cookie = JSON.parse(cookie);
									} catch (e) {}
								}

								jar[name] = cookie;

								if (key === name) {
									break;
								}
							} catch (e) {}
						}

						return key ? jar[key] : jar;
					}

					api.set = set;
					api.get = function (key) {
						return get(key, false /* read as raw */);
					};
					api.getJSON = function (key) {
						return get(key, true /* read as json */);
					};
					api.remove = function (key, attributes) {
						set(
							key,
							"",
							extend(attributes, {
								expires: -1,
							})
						);
					};

					api.defaults = {};

					api.withConverter = init;

					return api;
				}

				return init(function () {});
			});
		});

		function isTruthy(x) {
			return R.allPass([R.complement(R.isEmpty), R.complement(R.isNil)])(
				x
			);
		}
		function capitalize(str) {
			return R.replace(/^./, R.toUpper)(str);
		}
		function preAppendSelected(capitalizeKey) {
			return "selected" + capitalizeKey;
		}
		function getSelectedCookiesByArray(array) {
			var _cookiesGet = function (key) {
				return js_cookie.get(key);
			};
			return R.map(R.pipe(capitalize, preAppendSelected, _cookiesGet))(
				array
			);
		}
		function getCookiesWith(activityCode) {
			return function (cookiesKey) {
				return js_cookie.get(activityCode + cookiesKey);
			};
		}
		function getUrlWithSlash(url) {
			var removeSuffixOfHTML = R.replace(/([a-zA-z0-9])+(.html)$/i, "");
			var isExistSlash = R.pipe(
				removeSuffixOfHTML,
				R.last,
				R.equals("/")
			);
			var appendSlashIfNotExist = R.ifElse(
				isExistSlash,
				removeSuffixOfHTML,
				function (url) {
					return removeSuffixOfHTML(url) + "/";
				}
			);
			return appendSlashIfNotExist(url);
		}
		function getRedirectUrlAfterLogin() {
			var url = window.location.origin + window.location.pathname;
			return getUrlWithSlash(url) + "success.html";
		}
		function removeAllCookiesExcludeGA() {
			var getCookiesKey = R.match(/[^ =;]+(?=\=)/g);
			var isGAKey = R.pipe(R.head, R.equals("_"));
			var willDeleteCookiesKey = R.filter(
				R.complement(isGAKey),
				getCookiesKey(document.cookie)
			);
			R.map(js_cookie.remove, willDeleteCookiesKey);
		}

		var getUserAgent = R.path(["navigator", "userAgent"]);
		var getClientWidth = R.path(["body", "clientWidth"]);
		var isPhone = R.pipe(
			getUserAgent,
			R.test(/Android|webOS|iPhone|iPad|BlackBerry/i)
		);
		function getPopupCSSLinkByUserAgent(window) {
			var cssLinkOrigin = function (type) {
				return (
					"https://restw-download.vsplay.com/res_tw/common/css/rolePopup-" +
					type
				);
			};
			var cssLinkTypeOfPc = R.always(cssLinkOrigin("pc.css"));
			var cssLinkTypeOfMb = R.pipe(
				getClientWidth,
				R.cond([
					[R.lte(R.__, 640), R.always("moRem.css")],
					[R.lte(R.__, 750), R.always("mo750.css")],
					[R.T, R.always("mo1000.css")],
				]),
				cssLinkOrigin
			);
			var cssLinkType = R.ifElse(
				isPhone,
				function () {
					return cssLinkTypeOfMb(document);
				},
				cssLinkTypeOfPc
			)(window);
			return cssLinkType;
		}
		function importPopupCSSOfREMLink() {
			var link = document.createElement("link");
			link.id = "remCssLink";
			link.type = "text/css";
			link.rel = "stylesheet";
			link.href = getPopupCSSLinkByUserAgent(window);
			link.onload = function () {
				window.MoverRamda.isPrepareRolePopup = true;
			};
			var head = document.getElementsByTagName("head")[0];
			head.appendChild(link);
			return;
		}
		function buildLogin(redirectUrlAfterLogin, activityCode) {
			return function () {
				window.location.href =
					"https://www.movergames.com/enter/login?from=" +
					redirectUrlAfterLogin +
					encodeURIComponent("?from=") +
					activityCode;
			};
		}
		function logout() {
			removeAllCookiesExcludeGA();
			window.location.reload();
		}
		function isExistValueOfCookies(activityCode, property) {
			var getCookiesWithActivityCode = getCookiesWith(activityCode);
			return R.pipe(
				R.map(R.pipe(getCookiesWithActivityCode, isTruthy)),
				R.any(R.equals(true))
			)(property);
		}
		function isLogin(activityCode) {
			return isExistValueOfCookies(activityCode, [
				"loginSign",
				"loginId",
				"loginTimestamp",
			]);
		}
		function isSelectedRole() {
			return isExistValueOfCookies("selected", ["RoleId"]);
		}

		function getGameAPIUrlWith(APIName) {
			return "https://game.movergames.com" + APIName;
		}
		function getBasicParams(gameCode, activityCode) {
			var getCookiesWithActivityCode = getCookiesWith(activityCode);
			var paramsKeyOfLogin = [
				"loginId",
				"loginTimestamp",
				"loginSign",
				"userId",
			];
			var paramsKeyOfSelected = ["roleId", "serverCode"];
			var getValueOfKey = R.map(getCookiesWithActivityCode);
			var paramsOfLogin = R.zipObj(
				paramsKeyOfLogin,
				getValueOfKey(paramsKeyOfLogin)
			);
			var selectedCookiesKey = R.map(
				R.pipe(capitalize, preAppendSelected)
			)(paramsKeyOfSelected);
			var paramsOfSelected = R.zipObj(
				paramsKeyOfSelected,
				R.map(function (key) {
					return js_cookie.get(key);
				})(selectedCookiesKey)
			);
			return __assign(
				__assign(__assign({}, paramsOfLogin), paramsOfSelected),
				{ gameCode: gameCode, activityCode: activityCode }
			);
		}
		function jsonp(url, params, config) {
			var $jsonp = $.ajax(
				__assign(
					{
						async: false,
						url: url,
						type: "get",
						data: __assign(__assign({}, params), {
							crossdomain: true,
						}),
						crossDomain: true,
						dataType: "jsonp",
						jsonp: "jsoncallback",
						timeout: 5000,
						error: function () {
							messagePopup("網絡異常");
						},
					},
					config
				)
			);
			return $jsonp;
		}
		function $API(url, params, config) {
			return jsonp(url, params, config);
		}
		function getServerList(gameCode) {
			return $API(
				getGameAPIUrlWith(
					"/gameServer_findAllServerByGameCodePC.shtml"
				),
				{ gameCode: gameCode }
			);
		}
		function getRoleList(gameCode, activityCode, serverCode) {
			var uid = getCookiesWith(activityCode)("userId");
			return $API(getGameAPIUrlWith("/gameRole_findRole.shtml"), {
				gameCode: gameCode,
				serverCode: serverCode,
				uid: uid,
			});
		}

		function createLoader() {
			var style = document.createElement("style");
			style.innerText =
				'\n  #loading{\n    position: fixed;\n    width: 100%;\n    height: 100%;\n    left: 0;\n    top: 0;\n    background: rgba(0, 0, 0, 0.5);\n    z-index: 9999999;\n    display:none;\n  }\n  .lds-roller {\n    display: inline-block;\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    width: 80px;\n    height: 80px;\n    transform: translate(-50%, -50%);\n  }\n  .lds-roller div {\n    animation: lds-roller 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;\n    transform-origin: 40px 40px;\n  }\n  .lds-roller div:after {\n    content: " ";\n    display: block;\n    position: absolute;\n    width: 7px;\n    height: 7px;\n    border-radius: 50%;\n    background: #fff;\n    margin: -4px 0 0 -4px;\n  }\n  .lds-roller div:nth-child(1) {\n    animation-delay: -0.036s;\n  }\n  .lds-roller div:nth-child(1):after {\n    top: 63px;\n    left: 63px;\n  }\n  .lds-roller div:nth-child(2) {\n    animation-delay: -0.072s;\n  }\n  .lds-roller div:nth-child(2):after {\n    top: 68px;\n    left: 56px;\n  }\n  .lds-roller div:nth-child(3) {\n    animation-delay: -0.108s;\n  }\n  .lds-roller div:nth-child(3):after {\n    top: 71px;\n    left: 48px;\n  }\n  .lds-roller div:nth-child(4) {\n    animation-delay: -0.144s;\n  }\n  .lds-roller div:nth-child(4):after {\n    top: 72px;\n    left: 40px;\n  }\n  .lds-roller div:nth-child(5) {\n    animation-delay: -0.18s;\n  }\n  .lds-roller div:nth-child(5):after {\n    top: 71px;\n    left: 32px;\n  }\n  .lds-roller div:nth-child(6) {\n    animation-delay: -0.216s;\n  }\n  .lds-roller div:nth-child(6):after {\n    top: 68px;\n    left: 24px;\n  }\n  .lds-roller div:nth-child(7) {\n    animation-delay: -0.252s;\n  }\n  .lds-roller div:nth-child(7):after {\n    top: 63px;\n    left: 17px;\n  }\n  .lds-roller div:nth-child(8) {\n    animation-delay: -0.288s;\n  }\n  .lds-roller div:nth-child(8):after {\n    top: 56px;\n    left: 12px;\n  }\n  @keyframes lds-roller {\n    0% {\n      transform: rotate(0deg);\n    }\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n\n  ';
			$("head").append(style);
			$("body").append(
				'<div id="loading" class="loading"><div class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div></div>'
			);
			return;
		}
		function createOneGameItem(game) {
			return (
				'\n  <a id="' +
				game.gameCode +
				'" data-game-code="' +
				game.gameCode +
				'" data-game-name="' +
				game.gameName +
				'" class="popup-game-option-item">' +
				game.gameName +
				"</a>\n  "
			);
		}
		function createPopDomEle() {
			return '\n          <div class="pop-bg dynamic-login-pop" id="login-pop">\n            <a class="close-btn b-close"></a>\n            <div class="pop-top">\n              \u767B\u5165\u60A8\u7684\u5E33\u865F\n            </div>\n\n            <div class="pop-con">\n              <div class="login-after">\n                <div class="border select-box-group">\n                  <div class="select-box select-game-box">\n                      <span class="line-bg"><img src="https://restw-download.vsplay.com/res_tw/common/images/choose_game.jpg">\u9078\u64C7\u904A\u6232</span>\n                      <a class="line-option" id="gameSpan">\u8ACB\u9078\u64C7\u904A\u6232</a>\n                      <div class="option-list" id="game">\n\n                      </div>\n                  </div>\n                  <div class="select-box select-server-box">\n                    <span class="line-bg">\n                      <img\n                        src="https://restw-download.vsplay.com/res_tw/common/images/choose_machine.jpg"\n                      />\n                      \u9078\u64C7\u670D\u52D9\u5668\n                    </span>\n                    <a class="line-option" id="serverSpan">\n                      \u8ACB\u9078\u64C7\u670D\u52D9\u5668\n                    </a>\n                    <div class="option-list" id="server">\n                      <a id="server1"></a>\n                    </div>\n                  </div>\n                  <div class="select-box select-role-box">\n                    <span class="line-bg"\n                      ><img\n                        src="https://restw-download.vsplay.com/res_tw/common/images/choose_role.jpg"\n                      />\u9078\u64C7\u89D2\u8272</span\n                    ><a class="line-option" id="roleSpan">\u8ACB\u9078\u64C7\u89D2\u8272</a>\n                    <div class="option-list" id="role"></div>\n                  </div>\n                </div>\n                <div class="btn-mar">\n                  <a class="pop-login-btn" id="login-role-confirm"></a>\n                </div>\n              </div>\n            </div>\n          </div>\n    ';
		}
		function createOneServerItem(serverOption) {
			var serverPrefix = serverOption.serverPrefix,
				ServerName = serverOption.ServerName,
				ServerCode = serverOption.ServerCode,
				gameCode = serverOption.gameCode;
			return (
				'\n    <a\n        data-game-code="' +
				gameCode +
				'"\n        data-server-name="' +
				ServerName +
				'"\n        data-server-code="' +
				ServerCode +
				'"\n        data-server-prefix="' +
				serverPrefix +
				'"\n        class="popup-server-option-item"\n    >\n        ' +
				serverPrefix +
				"_" +
				ServerName +
				"\n    </a>\n    "
			);
		}
		function createOneRoleItem(roleList) {
			var roleId = roleList.roleid,
				roleName = roleList.name,
				level = roleList.level;
			return (
				'\n    <a\n        data-role-id="' +
				roleId +
				'"\n        data-level="' +
				level +
				'"\n        data-role-name="' +
				roleName +
				'"\n        class="popup-role-option-item"\n    >\n        ' +
				roleName +
				"\n    </a>\n    "
			);
		}
		function showLoading() {
			$("#loading").fadeIn();
		}
		function hideLoading() {
			$("#loading").fadeOut();
		}
		function prepareRolePopup(game) {
			importPopupCSSOfREMLink();
			var loginPopEle = $("#login-pop");
			var isExistElement = R.complement(R.propEq("length", 0));
			var removeLoginPopEleWhenExist = R.when(
				isExistElement,
				function () {
					return loginPopEle.remove();
				}
			);
			removeLoginPopEleWhenExist(loginPopEle);
			var popDomEle = createPopDomEle();
			$("body").append(popDomEle);
			if (R.gt(game.length, 1)) {
				renderGameListOfPopup(game);
			} else {
				$(".select-game-box").hide();
				renderServerListOfPopup(R.head(game).gameCode);
			}
			bindRoleEvent();
			return;
		}
		function bindRoleEvent() {
			$(".select-box").click(toggleSelectOptionList);
			$(".select-box-group").click(saveSelectedValueOfPopup);
			$("#login-role-confirm").click(validateSelected);
		}
		function renderGameListOfPopup(game) {
			var getGameListDOMStr = R.pipe(
				R.map(createOneGameItem),
				R.join("")
			);
			$("#game").append(getGameListDOMStr(game));
		}
		function renderServerListOfPopup(gameOptionItemDataset) {
			var gameCode = gameOptionItemDataset.gameCode,
				gameName = gameOptionItemDataset.gameName;
			console.log("TCL: renderServerListOfPopup -> gameCode", gameCode);
			$("#gameSpan").text("" + gameName);
			$("#serverSpan").text("请選擇服務器");
			$("#roleSpan").text("请選擇角色");
			resetSelectedValueWhenSwitchGame();
			getServerList(gameCode || gameOptionItemDataset).done(function (
				res
			) {
				var getServerListDOMStr = R.pipe(
					R.head,
					R.path(["ServerList"]),
					R.map(createOneServerItem),
					R.join("")
				);
				$("#server").empty().append(getServerListDOMStr(res));
			});
		}
		function renderRoleListOfPopup(serverOptionItemDataset) {
			var gameCode = serverOptionItemDataset.gameCode,
				serverPrefix = serverOptionItemDataset.serverPrefix,
				serverName = serverOptionItemDataset.serverName,
				serverCode = serverOptionItemDataset.serverCode;
			$("#serverSpan").text(serverPrefix + "_" + serverName);
			$("#roleSpan").text("请選擇角色");
			$("#role").empty();
			var activityCode = js_cookie.get("selectedActivityCode");
			showLoading();
			getRoleList(gameCode, activityCode, serverCode).done(function (
				res
			) {
				var getRoleListDOMStr = R.pipe(
					R.head,
					R.pathOr([], ["list"]),
					R.map(createOneRoleItem),
					R.join("")
				);
				$("#role").empty().append(getRoleListDOMStr(res));
				hideLoading();
			});
		}
		function resetSelectedValueWhenSwitchGame() {
			var willDeletedKey = ["roleId", "roleName", "level", "serverCode"];
			var _setCookiesKeyEmpty = function (key) {
				js_cookie.set(key, "");
			};
			R.map(R.pipe(capitalize, preAppendSelected, _setCookiesKeyEmpty))(
				willDeletedKey
			);
		}
		function validateSelected(e) {
			e.stopPropagation();
			var selectedServerKey = ["serverName", "serverCode", "gameCode"];
			var selectedRoleKey = ["roleId", "roleName", "level"];
			var isExistValueOfKey = R.pipe(
				getSelectedCookiesByArray,
				R.map(isTruthy),
				R.all(R.equals(true))
			);
			if (!isExistValueOfKey(selectedServerKey)) {
				messagePopup("請選擇服務器");
				return;
			}
			if (!isExistValueOfKey(selectedRoleKey)) {
				messagePopup("請選擇角色");
				return;
			}
			isStopLoginout = true;
			$("#login-pop").bPopup().close();
		}
		function toggleSelectOptionList(event) {
			$(event.currentTarget).find(".option-list").toggle();
		}
		function saveSelectedValueOfPopup(event) {
			var getTargetClassList = R.pipe(
				R.path(["target", "classList"]),
				Array.from
			);
			var anyContains = function (className) {
				return R.any(R.contains(className));
			};
			var isClickedOptionItemOfGame = R.pipe(
				getTargetClassList,
				anyContains("popup-game-option-item")
			);
			var isClickedOptionItemOfServer = R.pipe(
				getTargetClassList,
				anyContains("popup-server-option-item")
			);
			var isClickedOptionItemOfRole = R.pipe(
				getTargetClassList,
				anyContains("popup-role-option-item")
			);
			var getTargetDataset = R.path(["target", "dataset"]);
			R.when(
				isClickedOptionItemOfGame,
				R.pipe(getTargetDataset, renderServerListOfPopup)
			)(event);
			R.when(
				isClickedOptionItemOfServer,
				R.pipe(getTargetDataset, renderRoleListOfPopup)
			)(event);
			R.when(
				isClickedOptionItemOfRole,
				R.pipe(getTargetDataset, function (dataset) {
					$("#roleSpan").text(R.path(["roleName"], dataset));
				})
			)(event);
			R.when(
				R.anyPass([
					isClickedOptionItemOfGame,
					isClickedOptionItemOfServer,
					isClickedOptionItemOfRole,
				]),
				R.pipe(
					R.path(["target", "dataset"]),
					R.toPairs,
					R.map(function (x) {
						return js_cookie.set(
							"selected" + capitalize(R.head(x)),
							R.last(x),
							{ expires: 7 }
						);
					})
				)
			)(event);
		}
		function rolePopup() {
			isStopLoginout = false;

			$("#login-pop").bPopup({
				onClose: function () {
					if (isStopLoginout) {
						window.location.reload();
						return;
					}
					console.log("进行注销");
					logout();
				},
			});
		}
		function rolePopupWhenIsLoginButNotSelectedRole(activityCode) {
			R.pipe(R.juxt([isLogin, isSelectedRole]), function (booleanResult) {
				var isLogin$$1 = R.pipe(R.head, R.equals(true));
				var isSelectedRole$$1 = R.pipe(R.last, R.equals(true));
				R.when(
					R.both(isLogin$$1, R.complement(isSelectedRole$$1)),
					function () {
						rolePopup();
					}
				)(booleanResult);
			})(activityCode);
		}
		function messagePopup(text) {
			$("#pop-div1").bPopup();
			$("#pop-div1 p").html(text);
		}

		function trackGA(eventCategory, eventAction, eventLabel) {
			gtag("event", eventAction, {
				event_category: eventCategory,
				event_label: eventLabel,
			});
		}
		function trackGAList(trackList) {
			var _loop_1 = function (selector) {
				if (trackList.hasOwnProperty(selector)) {
					var event_1 = trackList[selector];
					$(selector).click(function () {
						trackGA(event_1[0], event_1[1], event_1[2]);
					});
				}
			};
			for (var selector in trackList) {
				_loop_1(selector);
			}
		}

		var Mover = (function () {
			function Mover(options) {
				this.activityCode = options.activityCode;
				this.gameCode = options.gameCode;
				if (!isSelectedRole()) {
					prepareRolePopup(options.selectGames);
				}
				js_cookie.set("selectedActivityCode", this.activityCode);
				createLoader();
			}
			Mover.prototype.init = function () {
				this.rolePopupWhenIsLoginButNotSelectedRole();
				return this;
			};
			Mover.prototype.getIsLogin = function () {
				return isLogin(this.activityCode);
			};
			Mover.prototype.getIsSelectedRole = function () {
				return isSelectedRole();
			};
			Mover.prototype.login = function () {
				var redirectUrlAfterLogin = getRedirectUrlAfterLogin();
				buildLogin(redirectUrlAfterLogin, this.activityCode)();
			};
			Mover.prototype.logout = function () {
				logout();
			};
			Mover.prototype.showLoading = function () {
				showLoading();
			};
			Mover.prototype.hideLoading = function () {
				hideLoading();
			};
			Mover.rolePopup = function () {
				rolePopup();
			};
			Mover.msgPopup = function (text) {
				messagePopup(text);
			};
			Mover.prototype.rolePopupWhenIsLoginButNotSelectedRole =
				function () {
					var _this = this;
					if (Mover.isPrepareRolePopup) {
						rolePopupWhenIsLoginButNotSelectedRole(
							this.activityCode
						);
					} else {
						setTimeout(function () {
							_this.rolePopupWhenIsLoginButNotSelectedRole();
						}, 100);
					}
				};
			Mover.$API = function (url, params, config) {
				return $API(url, params, config);
			};
			Mover.prototype.$API = function (url, params, config) {
				var basicParams = getBasicParams(
					this.gameCode,
					this.activityCode
				);
				return $API(
					url,
					__assign(__assign({}, basicParams), params),
					config
				);
			};
			Mover.prototype.getServerList = function () {
				return getServerList(this.gameCode);
			};
			Mover.prototype.trackGA = function (
				eventCategory,
				eventAction,
				eventLabel
			) {
				trackGA(eventCategory, eventAction, eventLabel);
			};
			Mover.prototype.trackGAList = function (trackList) {
				trackGAList(trackList);
			};
			Mover.isPrepareRolePopup = false;
			Mover.Cookies = js_cookie;
			return Mover;
		})();

		return Mover;
	}.bind(window)
);

